"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-user.tsx
var User = function User(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.0051994 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM12 4.28571C12.7629 4.28571 13.5086 4.51193 14.1429 4.93576C14.7772 5.35959 15.2716 5.96199 15.5635 6.66679C15.8555 7.37159 15.9319 8.14713 15.783 8.89535C15.6342 9.64356 15.2668 10.3308 14.7274 10.8703C14.188 11.4097 13.5007 11.7771 12.7525 11.9259C12.0043 12.0747 11.2287 11.9983 10.5239 11.7064C9.81914 11.4145 9.21673 10.9201 8.79291 10.2858C8.36908 9.65146 8.14286 8.90573 8.14286 8.14286C8.14173 7.63601 8.24073 7.13394 8.43417 6.66546C8.62761 6.19698 8.91168 5.77132 9.27007 5.41292C9.62847 5.05453 10.0541 4.77046 10.5226 4.57702C10.9911 4.38358 11.4932 4.28458 12 4.28571ZM18.8571 19.6457C16.9774 21.3448 14.5338 22.2856 12 22.2856C9.46616 22.2856 7.02256 21.3448 5.14286 19.6457V19.1486C5.1104 17.975 5.5423 16.836 6.34475 15.9789C7.1472 15.1219 8.25538 14.6161 9.42858 14.5714H14.5714C15.7393 14.6183 16.8423 15.1212 17.6435 15.9721C18.4448 16.8231 18.8805 17.9543 18.8571 19.1229V19.6457Z",
    fill: "currentColor"
  }));
};

var _default = User;
exports.default = _default;